module.exports = __webpack_public_path__ + "assets/img/select_products8.6e425891.svg";